import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { MapStarButton as Button } from 'ui-components'
import { useAuth, useFederatedAuth } from 'user-auth'

import { useLikeMap } from '~map-preview/queries/useLikeMap'
import { useUnlikeMap } from '~map-preview/queries/useUnlikeMap'
import { useMap, useMapId } from '~map-preview/states/map'

let once = false
const MapStarButton = () => {
  const router = useRouter()
  const mapId = useMapId()
  const { likes = 0, liked = false } = useMap()

  const { authenticated } = useAuth()
  const { gotoSignInPage } = useFederatedAuth()

  const { mutate: like } = useLikeMap()
  const { mutate: unlike } = useUnlikeMap()

  const handleLike = () => {
    like(mapId)
  }

  const handleUnlike = () => {
    unlike(mapId)
  }

  const handleSignInClick = () => {
    gotoSignInPage({
      redirect: router.asPath + '?like=true'
    })
  }

  const clearQuery = () => {
    delete router.query.like
    router.replace({ query: router.query }, undefined, {
      shallow: true
    })
  }

  useEffect(() => {
    const autoLike = async () => {
      if (router.query?.like !== 'true') return
      if (once) return

      if (!liked) await like(mapId)
      clearQuery()
      once = true
    }

    autoLike()
  }, [])

  return (
    <Button
      authenticated={authenticated}
      counts={likes}
      selected={liked}
      onSelect={handleLike}
      onUnselect={handleUnlike}
      onSignInClick={handleSignInClick}
    />
  )
}

export { MapStarButton }
